import { render, staticRenderFns } from "./DataPlots.vue?vue&type=template&id=99dffb7e"
import script from "./DataPlots.vue?vue&type=script&lang=js"
export * from "./DataPlots.vue?vue&type=script&lang=js"
import style0 from "./DataPlots.vue?vue&type=style&index=0&id=99dffb7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports